import React, {memo, useState} from 'react';
import {easing, useAnim} from 'use-anim';

import * as iter from '../utils/iter';

export default memo(
	/**
	 * @param {{color: string, animation?: boolean} & React.SVGProps<SVGSVGElement>} param0
	 * @returns {React.ReactElement} ...
	 */
	function StripedBox({color, animation = false, ...restArgs}) {
		const [skipStripes, setSkipStripes] = useState(
			/** @returns {number | null} */
			() => null
		);

		useAnim(
			{
				started: animation,
				duration: 2000,
				easing: easing.linear,
			},
			(t) => {
				const s = Math.floor(20 - t * 20);
				setSkipStripes(s);
			},
		);

		// skip rendering the state before the animation
		if (animation && skipStripes === null) {
			return null;
		}

		const stripes = iter.enumerate()
			.take(20)
			.drop(skipStripes || 0)
			.map((i) => (
				<rect
					key={i}
					x={`${i * 5}%`}
					y="0"
					width={`${4.5 - (i+1)/20 * 4}%`}
					height="100%"
					fill={color}
				/>
			))
			.toArray();

		return (
			<svg {...restArgs}>
				{stripes}
			</svg>
		);
	}
);
